import React, { useState } from 'react';
import './confirmtoast.scss';

export const useConfirmToast = () => {
    const [toastData, setToastData] = useState(null);

    const showConfirm = (message, onConfirm, onCancel) => {
        return new Promise((resolve) => {
            setToastData({
                message,
                onConfirm: () => {
                    setToastData(null);
                    resolve(true);
                    if (onConfirm) onConfirm();
                },
                onCancel: () => {
                    setToastData(null);
                    resolve(false);
                    if (onCancel) onCancel();
                }
            });
        });
    };

    const ConfirmToastComponent = () => {
        if (!toastData) return null;
        
        return (
            <div className="confirm-toast show">
                <div className="confirm-toast-content realistic">
                    <div className="confirm-toast-icon">
                    <svg 
                        className="cart-icon"
                        viewBox="0 0 24 24"
                        fill="#edf5e1"
                        width="28"
                        height="28"
                    >
                        <path d="M7 4H5L4 6v2h2l3.6 7.59-1.35 2.44A2 2 0 0 0 10 22h10v-2H10l1.1-2h7.45a2 2 0 0 0 1.75-1.03l3.58-6.49A1 1 0 0 0 23 9H8.21L7 4z"/>
                    </svg>
                    </div>
                    <div className="confirm-toast-message">
                        <p className="toast-text" dangerouslySetInnerHTML={{ __html: toastData.message }}/>
                    </div>
                    <div className="confirm-toast-actions">
                        <button 
                            className="toast-btn cancel" 
                            onClick={toastData.onCancel}
                        >
                            Annulla
                        </button>
                        <button 
                            className="toast-btn confirm" 
                            onClick={toastData.onConfirm}
                        >
                            Conferma
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return { showConfirm, ConfirmToastComponent };
};
